import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth-service';



export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService)
  const router = inject(Router)

  if(!authService.isAuthentificated()){
    authService.logout()
    router.navigateByUrl("/login")
    return false
  }

  return true;
};

export const loggedGuardGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService)
  const router = inject(Router)

  if(authService.isAuthentificated()){
    router.navigateByUrl("/")
    return false
  }

  return true;
};
